// src/pages/BoxLabelPrint/DlsLogo.jsx
import { Box } from "@chakra-ui/react";
import { darkLogo, useTableColors } from "../../Utils";

export default function DlsLogo({ clientName, boxContent, printRef }) {
  const colors = useTableColors();

  return (
    <Box bg={colors?.theadBg || "transparent"} p={2} borderRadius={10}>
      <div
        ref={printRef}
        style={{
          width: "6in",
          height: "4in",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: "1px solid #ccc",
          justifyContent: "center",
          background: "#fff",
        }}
      >
        {/* IMPORTANT: crossOrigin helps if the logo is served with proper CORS headers */}
        <img
          src={darkLogo}
          alt="DLS"
          crossOrigin="anonymous"
          style={{ marginBottom: "10px", maxWidth: "45%" }}
        />

        <h2 style={{ fontWeight: "bold", textAlign: "center", fontSize: 25, margin: 0 }}>
          {clientName}
        </h2>

        {boxContent?.trim() ? (
          <h2
            style={{
              // fontWeight: "bold",
              textAlign: "center",
              width: "100%",
              marginTop: "10px",
              fontSize: 20,
              marginBottom: 0,
            }}
          >
            {boxContent}
          </h2>
        ) : null}
      </div>
    </Box>
  );
}
